import { useDispatch, useSelector } from 'react-redux';
import { startFetch } from '../../services/fetch/startFetch';
import MesaEntradaService from '../../services/MesaEntradaService';
import {
  cleanDestinos,
  cleanTrackingTramitesDestinos,
  cleanTramites,
  getDestinos,
  getTrackingTramitesDestinos,
  getTramites,
  putTramites,
} from '../../reducers/mesaEntrada/mesaEntradaActions';
import { startAlerta } from '../../actions/ui/alertas';
import { deleteComprobanteDirecto, getComprobantesMesaEntrada } from '../../actions/mesaEntrada/mesaEntradaActions';
import { MENU_MESA_ENTRADA, TIPO_EFECTORES } from '../../utils/constants';
import { useValidationForm } from '../useValidationForm';
import { types } from '../../types/types';
import moment from 'moment';
import { padLeft } from '../../helpers/numbers';
import ContratacionesService from '../../services/ContratacionesService';

export const useMesaEntrada = () => {
  const dispatch = useDispatch();
  const validation = useValidationForm();

  const clean = {
    tramites: () => {
      cleanTramites();
    },
    destinos: () => {
      cleanDestinos();
    },
    trackingTramitesDestinos: () => {
      cleanTrackingTramitesDestinos();
    },
    cuentasContables: () => {
      dispatch({ type: types.contratacionesCuentasClean })
    }
  };

  const get = {
    tramites: () => {
      dispatch(
        startFetch(
          () => MesaEntradaService.getTramites(),
          (data) => {
            dispatch(getTramites(data));
          },
        ),
      );
    },
    destinos: () => {
      dispatch(
        startFetch(
          () => MesaEntradaService.getDestinos(),
          (data) => {
            dispatch(getDestinos(data));
          },
        ),
      );
    },
    expedientesOspeDirecto: (values) => {
      dispatch(
        startFetch(
          () => MesaEntradaService.getComprobantesOspeDirectoBuscador(values),
          (data) => {
            dispatch(getComprobantesMesaEntrada(data));
          },
        ),
      );
    },
    byId: {
      trackingTramitesDestinos: (id) => {
        dispatch(
          startFetch(
            () => MesaEntradaService.getTrackingTramitesDestinos(id),
            (data) => {
              dispatch(getTrackingTramitesDestinos(data));
            },
          ),
        );
      },
    },
  };

  const check = {
    comprobanteOspeDirecto: (comprobante, setValues, openModal) => {
      const startSet = (cuentas) => {
        setValues({
          ...comprobante,
          idTipoFactura: comprobante.tipoFactura.id,
          idTipoComprobante: comprobante.tipoComprobante.id,
          idTramite: comprobante.tramite.id,
          idProcedencia: comprobante.procedencia.id,
          fechaInicioVigencia: comprobante.fechaComprobante,
          nroSucursal: padLeft(comprobante.nroSucursal, 5, "0"),
          nroFactura: padLeft(comprobante.nroFactura, 8, "0"),
          fechaRecepcion: moment(),
          fechaFinVigencia: moment().add(comprobante?.plazoPago, 'days').format(),
          cuentasContables: cuentas.map((item, index) => ({
            idCuentaContable: item.id,
            importeCuenta: 0 === index ? comprobante.totalComprobante : 0,
            asignada: 0 !== index ? false : true,
          }))
        })
        openModal()
      }

      if (validation([
        {
          errorCondition: (
            comprobante?.efectorFacturacion?.fechaBajaEfector !== null &&
            moment(comprobante?.fechaBajaEfector).add(90, 'days') < moment()
          ),
          errorMessage: "El plazo de carga supero los 90 días de la fecha de baja del contrato"
        },
        {
          errorCondition: !comprobante?.efectorFacturacion?.idDatosBancarios || comprobante?.efectorFacturacion?.plazoPago === null,
          errorMessage: "El contrato no posee Datos Bancarios - Plazo Pago. Comuniquese con tesorería"
        },
        {
          errorCondition: !comprobante?.efectorFacturacion?.idIva,
          errorMessage: "El contrato no posee Condición de IVA en los Datos Bancarios. Comuniquese con tesorería"
        }
      ])) {
        if (comprobante?.idTipoEfector === TIPO_EFECTORES.PROVEEDOR) {
          dispatch(
            startFetch(
              () => ContratacionesService.obtenerCuentasContables(comprobante.idEfectorFacturacion),
              (body) => {
                dispatch({
                  type: types.contratacionesTraerCuentasSuccess,
                  payload: body,
                });
                if ([{
                  errorCondition: comprobante?.idTipoEfector === TIPO_EFECTORES.PROVEEDOR && body.length === 0,
                  errorMessage: "El Contrato de Proveedor no posee Plan de Cuentas en las Cuentas Contables. Comuniquese con tesorería'"
                }])
                  startSet(body);
              },
            ),
          );
        } else {
        startSet([]);
        }
      }
    }
  }

  const put = {
    tramite: (data) => {
      dispatch(
        startFetch(
          () => MesaEntradaService.putTramite(data),
          () => {
            dispatch(putTramites(data));
            dispatch(
              startAlerta(
                `Tramite - Destino Guardado`,
                'success',
                'Comando Exitoso',
              ),
            );
          },
        ),
      );
    },
    comprobanteOspeDirecto: (data) => {
      dispatch(
        startFetch(
          () => MesaEntradaService.confirmComprobantesOspeDirecto(data),
          () => {
            dispatch(deleteComprobanteDirecto(data.id));
            dispatch(
              startAlerta(
                `Comprobante Guardado`,
                'success',
                'Comando Exitoso',
              ),
            );
          },
        ),
      );
    },
    rechazarComprobanteDirecto: (data, handleNext) => {
      dispatch(
        startFetch(
          () => MesaEntradaService.rechazarComprobantesOspeDirecto(data.idComprobante, data.motivo),
          () => {
            dispatch(deleteComprobanteDirecto(data.idComprobante));
            handleNext()
            dispatch(
              startAlerta(
                `Comprobante Guardado`,
                'success',
                'Comando Exitoso',
              ),
            );
          },
        ),
      );
    },
  };

  return {
    get,
    put,
    clean,
    check,
    data: useSelector((state) => state.mesaEntrada),
    dataTransfer: {
      comprobantes: useSelector((state) => state.mesaEntrada.comprobantes),
      tramites: useSelector((state) => state.mesaEntrada.tramites),
      menu: {
        deseleccionado: useSelector((state) => state.mesaEntrada.activeBreadcrumb) === MENU_MESA_ENTRADA.DESELECCIONAR,
        recepcion: useSelector((state) => state.mesaEntrada.activeBreadcrumb) === MENU_MESA_ENTRADA.RECEPCION_COMPROBANTES,
        gestionPrestadores: useSelector((state) => state.mesaEntrada.activeBreadcrumb) === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_PRESTADORES,
        gestionDocumento: useSelector((state) => state.mesaEntrada.activeBreadcrumb) === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_DOCUMENTO,
        gestionDirecto: useSelector((state) => state.mesaEntrada.activeBreadcrumb) === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_OSPE_DIRECTO,
      },
    }
  };
};
